import { makeAutoObservable } from "mobx";
import { toast } from "../components/ui/toast";
import { AccountService } from "../services/account.service";

export default class AccountStore {
  private accountService = new AccountService();

  accounts: any[] = [];
  accountDetails: any = null;
  isLoading = false;
  
  // Credentials-related properties
  credentials: any = null;
  isLoadingCredential = false;

  constructor() {
    makeAutoObservable(this);
  }

  getAccountDetails = async () => {
    try {
      this.isLoading = true;
      // Mock account details for now - replace with actual API call when available
      this.accountDetails = {
        balance: 100.0,
        currency: "USD",
        lastUpdated: new Date().toISOString()
      };
    } catch (error: any) {
      toast.error(error.message || "Error fetching account details");
    } finally {
      this.isLoading = false;
    }
  };

  // Add missing credentials method
  getCredentials = async () => {
    try {
      this.isLoadingCredential = true;
      const response = await this.accountService.getCredentials();
      this.credentials = response.data;
    } catch (error: any) {
      toast.error(error.message || "Error fetching credentials");
    } finally {
      this.isLoadingCredential = false;
    }
  };

  fetchAccounts = async () => {
    try {
      this.isLoading = true;
      // Use the actual method from AccountService
      this.accounts = await this.accountService.fetchUserOrganizations();
    } catch (error: any) {
      toast.error(error.message || "Error fetching accounts");
    } finally {
      this.isLoading = false;
    }
  };

  createAccount = async (accountData: any) => {
    try {
      const newAccount = await this.accountService.createOrganization(accountData);
      this.accounts.push(newAccount);
      toast.success("Account created successfully");
    } catch (error: any) {
      toast.error(error.message || "Error creating account");
    }
  };

  updateAccount = async (id: string, accountData: any) => {
    try {
      const updatedAccount = await this.accountService.updateOrganization(id, accountData);
      const index = this.accounts.findIndex(account => account.id === id);
      if (index !== -1) {
        this.accounts[index] = updatedAccount;
      }
      toast.success("Account updated successfully");
    } catch (error: any) {
      toast.error(error.message || "Error updating account");
    }
  };

  deleteAccount = async (id: string) => {
    try {
      // Note: There's no delete method in AccountService, so this is a placeholder
      // await this.accountService.deleteAccount(id);
      this.accounts = this.accounts.filter(account => account.id !== id);
      toast.success("Account deleted successfully");
    } catch (error: any) {
      toast.error(error.message || "Error deleting account");
    }
  };
}
